var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNextPage = function SvgNextPage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "15px",
    viewBox: "0 0 8 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "back arrow copy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Collections-created-",
    transform: "translate(-888.000000, -862.000000)",
    fill: "#657480",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(280.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paginador",
    transform: "translate(328.000000, 608.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page1",
    transform: "translate(284.000000, 20.000000) scale(-1, 1) translate(-284.000000, -20.000000) translate(264.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.881097,16.3013577 C14.4308949,15.8803788 13.723914,15.9032694 13.3020109,16.3524853 C12.8801078,16.8017012 12.9030487,17.5071334 13.3532508,17.9281123 L19.078778,23.2819872 C19.5001188,23.6759783 20.1529438,23.6846519 20.5846488,23.3019946 L26.6247653,17.9481196 C27.0860415,17.5392509 27.1277984,16.8346783 26.718032,16.3744126 C26.3082656,15.914147 25.6021461,15.8724816 25.14087,16.2813503 L19.8628366,20.9597254 L14.881097,16.3013577 Z",
    id: "back-arrow-copy",
    transform: "translate(20.000000, 19.791667) rotate(90.000000) translate(-20.000000, -19.791667) "
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNextPage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nextPage.76496eb1.svg";
export { ForwardRef as ReactComponent };